import { Pipe, PipeTransform} from '@angular/core';
import { DatePipe } from '@angular/common';
import * as appApiResources from '../../shared/globalcontants';
import { isDate } from 'moment-timezone';

@Pipe({ name: 'dateformater' })
export class DateFormater implements PipeTransform {
  constructor(private datePipe: DatePipe) {
  }
  transform(value: any, args?: any): any {
    const dateFormat = localStorage.hasOwnProperty(appApiResources.dateFormate.toString()) ?
      localStorage.getItem(appApiResources.dateFormate.toString())
      : 'MM/DD/YYYY';
    const reformatValue = dateFormat.toLowerCase().replace(/mm/g, 'MM');
    if(isDate(value)) {
      const momentDateFormat = this.datePipe.transform(value, reformatValue);
      return momentDateFormat;
    }
  }
}